import * as React from 'react';

const styles = require('./KycStatusChip.pcss');

type Props = {
  flags: Record<string, boolean> | null;
};

const KycStatusChip: React.FC<Props> = ({ flags }) => {
  if (!flags) {
    return null;
  }

  return (
    <div className={flags.kycApproved ? styles.kycApproved : styles.kycNotApproved}>
      {flags.kycApproved ? 'KYC Approved' : 'KYC Not Approved'}
    </div>
  );
};

export default KycStatusChip;
